export const getLoginURL = () => {
  return '/auth/login';
};

export const getLogoutURL = () => {
  return '/auth/logout';
};
